import Crud from '../components/Color/Crud'
import Add from '../components/Color/Add'
import Edit from '../components/Color/Edit'

let routes = {
    path: '/colors',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/colors/add',
            name: 'Nova Cor',
            component: Add
        },
        {
            path: '/colors/edit/:id?',
            name: 'Editar Cor',
            component: Edit
        },
        {
            path: '/colors',
            name: 'Cores',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/color.js